import { createApp, ref } from 'vue'
import pinia from '@/helpers/pinia'

// Components
import productOptions from '@/pages/carpet/product-options.vue';

createApp(productOptions).use(pinia).provide('code', window.productCode).mount('#product-grid')